const CheckpointProofType = {
  audio: 'AUDIO',
  video: 'VIDEO',
  text: 'TEXT',
  file: 'FILE'
};

export { CheckpointProofType };
export default CheckpointProofType;
